import * as Sentry from '@sentry/nextjs';
import { OS_MAP } from 'bowser';
import fetchFromElectron from '../fetchFromElectron';
import fetchFromExtension from '../fetchFromExtension';

const getDeviceId = async (
  osName?: string,
  registrationDetails?: string,
): Promise<string | undefined> => {
  try {
    // Chromebook
    if (osName && osName === OS_MAP.ChromeOS) {
      const serialNumberResult = await fetchFromExtension('SERIAL_NUMBER');
      if (serialNumberResult.error) {
        throw new Error(serialNumberResult.error);
      }
      const serialNumber = serialNumberResult.data?.serialNumber;
      return serialNumber || undefined;
    }

    // Mac/Windows
    if (window.electron) {
      const deviceIdResult = await fetchFromElectron('DEVICE_ID');
      if (deviceIdResult.error) {
        throw new Error(deviceIdResult.error);
      }
      const deviceId = deviceIdResult.data?.deviceId;
      return deviceId || undefined;
    }
  } catch (err: unknown) {
    const error = new Error(
      JSON.stringify({
        error: String(err),
        registrationDetails,
      }),
    );

    Sentry.captureException(error);
    // eslint-disable-next-line no-console
    console.error('Error while fetching device id:', err);
  }

  return undefined;
};

export default getDeviceId;
